import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useBrandGroup'

import type { BrandGroupModel } from '@models/types'

const AgencyBrandGroupListItem = (props: { brandGroup: BrandGroupModel }) => {
  const { brandGroup: { id, title } } = props

  const { editBrandGroupUrl } = generateUrls({ id })

  return (
    <DashboardModuleListItem
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editBrandGroupUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyBrandGroupListItem
